import Education from './components/Education'
import Experience from './components/Experience'
import {OverviewCompany} from './components-company/Overview'
import PersonalInformation from './components/Personalnformation'
import Skill from './components/Skill'
import {CompanyJobList} from './components-company/CompanyJobList'

const tabsMenuCompany = [
  {
    title: 'Informasi',
    path: '/crafted/pages/profile/company-overview',
    isActive: false,
    component: OverviewCompany,
  },

  {
    title: 'Edit Informasi Perusahaan',
    path: '/crafted/pages/profile/company/information',
    isActive: false,
    component: PersonalInformation,
    isSeparator: true,
  },
  {
    title: 'Pekerjaan',
    path: '/crafted/pages/profile/company-job',
    isActive: false,
    component: CompanyJobList,
    isSeparator: true,
  },
]

export default tabsMenuCompany
